//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
export default {
  name: "PlaylistCard",
  props: ["searchTerm"],
  computed: {
    ...mapGetters(["allMediaFiles", "allUserPlaylists"]),
  },
  data() {
    return {
      activePlaylist: null,
      deletePlaylistDialog: false,
      delPL: null,
      canDelPL: false,
      inUseDevice: [],
      modalPL: {},
      plEditDialog: false,
      error: "",
    };
  },
  methods: {
    ...mapActions([
      "checkIfPlaylistIsInUseByID",
      "deletePlaylistByID",
      "editPlaylistByID",
    ]),
    filterPL: function(pl) {
      var app = this;

      return (this.filteredPlaylists = pl.filter(function(pl) {
        let regex = new RegExp("(" + app.searchTerm + ")", "i");
        return pl.NAME.match(regex);
      }));
    },
    deletePlaylist(playlist) {
      this.deletePlaylistByID(playlist.ID);

      this.$emit("activePlaylistChanged", null);
    },
    checkUsedPlaylist(playlist) {
      this.checkIfPlaylistIsInUseByID(playlist.ID).then((response) => {
        this.inUseDevice = response.data;
        if (response.data.length < 1) {
          this.canDelPL = true;
        } else {
          this.canDelPL = false;
        }
      });
    },
    editPL() {
      this.error = null;

      if (
        this.modalPL.NAME == "" ||
        this.modalPL.NAME == null ||
        this.modalPL.NAME == " "
      ) {
        this.error = "Please enter a name";
      } else {
        this.allPlaylists = [];
        var results = [];
        for (var i = 0; i < this.allUserPlaylists.length; i++) {
          this.allPlaylists.push(this.allUserPlaylists[i].NAME);
        }

        var a = this.allPlaylists.indexOf(this.modalPL.NAME);
        while (~a) {
          results.push(a);
          a = this.allPlaylists.indexOf(this.modalPL.NAME, a + 1);
        }

        console.log("MDE PL NAME IN USE:" + results);

        if (results.length > 1) {
          this.error = "Name alread in use";
        } else {
          let playlistColor = this.modalPL.COLOR;
          if (playlistColor.includes("#")) {
            playlistColor = playlistColor.substring(1);
          }

          const plinfo = {
            plID: this.modalPL.ID,
            plName: this.modalPL.NAME,
            plColor: playlistColor,
          };

          this.editPlaylistByID(plinfo).then(() => {
            this.plEditDialog = false;
          });
        }
      }
    },
  },
};
